import ActionTypes from '../actionTypes'

const initialState = {
  tickets: [],
  totalTickets: 0,
  summary: {},
  vehicleMap: {}
}

const breakdownTicketsReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case ActionTypes.BREAKDOWN_TICKETS.FETCH_LIST_SUCCESS:
      return { ...state, tickets: payload.tickets, totalTickets: payload.total }
    case ActionTypes.BREAKDOWN_TICKETS.FETCH_SUMMARY_SUCCESS:
      return { ...state, summary: payload }
    case ActionTypes.BREAKDOWN_TICKETS.FETCH_VEHICLE_MAP_SUCCESS:
      return { ...state, vehicleMap: payload }
    default:
      return state
  }
}

export default breakdownTicketsReducer
